export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker.38425da56b70ef687bf9.worker.js");
}
